import { createFileRoute } from '@tanstack/react-router';
import { fetchSalesOrderAttachments } from '@/api/orders';
import { OrderAttachmentsTab } from '@/app/(client)/orders/-components/OrderAttachmentsTab';
import { salesOrderAttachmentKeys } from '@/app/(client)/orders/-hooks/useSalesOrderAttachments';
import { queryClient } from '@/lib/utils/queryClient';

export const Route = createFileRoute(
  '/(client)/orders/(pages)/(detail)/sales-orders/$soId/attachments',
)({
  loader: ({ params }) =>
    queryClient.ensureQueryData({
      queryKey: salesOrderAttachmentKeys.detail(params.soId),
      queryFn: () => fetchSalesOrderAttachments(params.soId).then(r => r.data),
    }),
  component: SalesOrderAttachmentsRoute,
});

function SalesOrderAttachmentsRoute() {
  const { soId } = Route.useParams();
  return (
    <div className='h-full flex flex-col'>
      <OrderAttachmentsTab orderId={soId} type='SALES_ORDER' />
    </div>
  );
}
